export default "__VITE_ASSET__915f054e__"